import {useState} from 'react';
import HeaderPage from '../../components/header_page';
import Selector from '../../../selectors/pages/main/balance';
import {useSelector} from 'react-redux';

import Choose from './choose';
import Chime from './chime';
import Bitcoin from './bitcoin';
import CashApp from './cashapp';
import CashAppMerchant from './cashapp_merchant';
import PayPal from './paypal';
import USDT from './usdt';
import USDC from './usdc';
import ETH from './eth';
import Square from './square';
import VisaMC from './visamc';
import CashAppNew from './cashapp_new';

export default () => {
    const [stage, setStage] = useState('choose'),
          [method, setMethod] = useState(null),
          {wallet} = useSelector(Selector);

    return (
        <>
            <HeaderPage title={"Add Cash"} />

            {stage === "choose" && <Choose walletId={wallet.id} walletProject={wallet.project} wallet={wallet} cashapp_enabled={wallet.cashapp_enabled} onNext={method => {
                setMethod(method);
                setStage("method");
            }} />}

            {stage === "method" && (
                <>
                    {method === "bitcoin" && <Bitcoin />}
                    {method === "chime" && <Chime setMethod={setMethod} />}
                    {method === "cashapp_merchant" && <CashAppMerchant setMethod={setMethod} />}
                    {method === "cashapp" && <CashApp setMethod={setMethod} />}
                    {method === "cashapp_new" && <CashAppNew setMethod={setMethod} wallet={wallet} />}
                    {method === "square" && <Square setMethod={setMethod} />}
                    {method === "paypal" && <PayPal setMethod={setMethod} />}
                    {method === "usdt" && <USDT setMethod={setMethod} />}
                    {method === "usdc" && <USDC setMethod={setMethod} />}
                    {method === "eth" && <ETH setMethod={setMethod} />}
                    {method === "visamc" && <VisaMC setMethod={setMethod} />}
                </>
            )}
        </>
    )
}